const TrackingInfo = () => {
	return function () {

		// let window.trackingInfoTemplate = ''; // is defined in fusion..
		let trackingInfoStorage = window.localStorage.getItem('tracking_info');

		this.init = function () {
			if (window.trackingInfoTemplate && !trackingInfoStorage && document.getElementById('trackingInfo')) {
				document.getElementById('trackingInfo').outerHTML = window.trackingInfoTemplate;
			}
		};

		this.accept = () => {
			document.getElementById('tracking-info').style.display = 'none';
			window.localStorage.setItem('tracking_info', Date.now());
		};

		this.reset = () => {
			window.localStorage.removeItem('tracking_info');
			console.log('please reload the browser..');
		};

		this.sayHello = () => {
			console.log('Hello!');
		};

		return this;
	};
};

export default TrackingInfo;
